
<template>
    <div class="head-partner row col-xs-12 reduce-padding">
        <h1>News/Blog</h1>
        <hr />
    </div>

    <div class="globe-img">        
        <img class="home-portfolio-heroimg" src="/images/global.webp"/>
    </div>

    <div class="col-md-8 reduce-padding">
        <div class='page-body reduce-padding section col-xs-12'>
            <ul>
                <li v-for="post in posts.items" :key="post.id">
                    <router-link :to="{name: 'post', params: {id: post.id}}" class="post-heads">{{ post.title }}</router-link>
                    <div class="post-descr" v-html="post.summary"></div>
                    <router-link :to="{name: 'post', params: {id: post.id}}">Read more</router-link>
                </li>
                <a v-if="currentPageToken" class="nav-links prev-link" @click.prevent="back()" href="">&lt;&lt; Previous</a>
                <a v-if="posts.nextPageToken !== ''" class="nav-links next-link" @click.prevent="next()" href="">Next &gt;&gt;</a>
            </ul>
        </div>
    </div>
</template>

<style scoped>
</style>

<script>
import {useRoute} from "vue-router";

export default {
    async mounted() {
        useRoute()
    },

    created() {
        this.$watch(() => this.$route.params, () => {
            this.fetchData()
        }, {immediate: true})
    },

    methods: {
        back() {
            const pageToken = this.pageTokenHistory.pop()
            if (pageToken === undefined) {
                this.$router.push({name: 'posts'})
            }
            this.$router.push({name: 'posts', query: {pageToken: pageToken}})
        },

        next() {
            if (this.currentPageToken) {
                this.pageTokenHistory.push(this.currentPageToken)
            }

            this.$router.push({name: 'posts', query: {pageToken: this.posts.nextPageToken}})
        },

        fetchData() {
            const params = this.$route.query
            const serverUrl = import.meta.env.VITE_API_URL || ''
            const pageToken = params.pageToken || ''
            this.loading = true

            this.currentPageToken = pageToken

            fetch(`${serverUrl}/api/posts?pageToken=${pageToken}`)
                .then(response => response.json())
                .then(data => this.posts = data)
                .then(() => this.loading = false)
        }
    },

    data() {
        return {
            loading: false,
            currentPageToken: '',
            pageTokenHistory: [],
            posts: {
                nextPageToken: '',
                prevPageToken: '',
                items: []
            },
        }
    }
}
</script>
